function csvFileName(partnerName, partnerCode, start, end) {
  const formattedName = partnerName.split(" ").join("_").toLowerCase();
  return `stats_${formattedName}[${partnerCode}]_${start.substring(
    0,
    10
  )}_${end.substring(0, 10)}.csv`;
}

export default csvFileName;
